import React from 'react';
import { mdiKey } from '@mdi/js';
import Icon from '@mdi/react';
import { checkMedia } from '../../../app/common/helpers/othersHelpers';

export default function MViewItemCopyFormListItems({
  question,
  answers,
  handleEnter,
  isEdit,
  roundNumber,
}) {
  let answer =
    answers?.[0] && answers?.find((i) => i.key + '' === question.key + '');

  let optionQuestion =
    question?.questionType === 'optionQuestion' ||
    question?.questionType === 'rightWrongQuestion'
      ? true
      : false;

  let options = question?.options;

  let questionDetail = optionQuestion ? (
    <>
      <div
        className='ck-content'
        dangerouslySetInnerHTML={{
          __html: checkMedia({ string: question?.question }),
        }}
      ></div>
      <p>
        {options.map((i, index) => (
          <span key={index} className='c-tag'>
            {i}
          </span>
        ))}
      </p>
    </>
  ) : (
    <div
      className='ck-content'
      dangerouslySetInnerHTML={{
        __html: checkMedia({ string: question?.question }),
      }}
    ></div>
  );

  return (
    <tr>
      <td className='has-text-centered middle'>{question?.no}</td>
      <td className='middle'>{questionDetail}</td>
      <td className='middle'>
        <div className='mt-2'>
          <span className='c-tag' style={{ position: 'relative' }}>
            <span
              className='icon is-small'
              style={{ position: 'absolute', top: 2 }}
            >
              <Icon path={mdiKey} size={1} />
            </span>
            <span style={{ marginLeft: 20 }}>: {answer?.answer}</span>
          </span>
        </div>
      </td>
    </tr>
  );
}
